import { render, staticRenderFns } from "./ConfigLocationsFilter.vue?vue&type=template&id=51cf1aa8&scoped=true&"
import script from "./ConfigLocationsFilter.vue?vue&type=script&lang=js&"
export * from "./ConfigLocationsFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51cf1aa8",
  null
  
)

export default component.exports